/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Contract } from '@ethersproject/contracts';
import useActiveWeb3React from '../hooks/useActiveWeb3React';
import Web3 from 'web3';
import { JsonRpcSigner, Web3Provider } from '@ethersproject/providers';
import { getContract } from '../functions/getContract';
import { isMainnet } from '../configs/Configs.env';
import contractBusd from '../contracts/mint.json';
import contractERC20 from '../contracts/erc20.json';

// returns null on errors
export function useContract(address: string | undefined, ABI: any, withSignerIfPossible = true): Contract | null {
    const { library, account } = useActiveWeb3React();

    return React.useMemo(() => {
        if (!address || !ABI || !library) return null;
        try {
            return getContract(address, ABI, library, withSignerIfPossible && account ? account : undefined);
        } catch (error) {
            console.error('Failed to get contract', error);
            return null;
        }
    }, [address, ABI, library, withSignerIfPossible, account]);
}

export function useBusdContract(withSignerIfPossible?: boolean): Contract | null {
    const contractABI = contractBusd.abi;
    const contractAddr = isMainnet ? contractBusd.address.mainnet : contractBusd.address.testnet;
    return useContract(contractAddr, contractABI, withSignerIfPossible);
}

export function useERC20Contract(withSignerIfPossible: boolean, depositAddress: string): Contract | null {
    return useContract(depositAddress, contractERC20, withSignerIfPossible);
}
export const getErc20Contract = (address: string, library?: Web3Provider, account?: string) => {
    if (!library) return null;
    return getContract(address, contractERC20, library, account);
};
